import { GraphQLClient } from "graphql-request";

export const getGraphQLEndpoint = () =>
	window.SAM._env_.REACT_APP_BASE_GRAPHQL_URL;

export const getDashboardApiBaseUrl = () =>
	getGraphQLEndpoint().replace(/\/graphql\/?$/, "");

const getClient = (userId?: string, controller?: AbortController) => {
	const endpoint = getGraphQLEndpoint();

	const client = new GraphQLClient(endpoint, {
		credentials: "include",
		/**
		 * Resolve fetch at call time. graphql-request/cross-fetch captures
		 * window.fetch at module load, which is before the New Relic agent
		 * patches it. Passing window.fetch by reference recaptures it.
		 */
		fetch: (...args) => window.fetch(...args),
		headers: {
			["SAM-Context"]: window.btoa(JSON.stringify({ user_id: userId })),
			["X-Requested-With"]: "XMLHttpRequest",
		},
		mode: "cors",
		signal: controller?.signal,
	});

	return client;
};

export default getClient;
